













































































































































































































































































































































































































































































































































import Vue from 'vue';
import { saveAs } from 'file-saver';
import cloneDeep from 'lodash/cloneDeep';
import colors from 'vuetify/lib/util/colors';
import Convert from '@/classes/convert';
import SaveDataView from '@/components/saveData/SaveDataView.vue';
import SaveDataTab from '@/components/saveData/SaveDataTab.vue';
import ShareDialog from '@/components/saveData/ShareDialog.vue';
import UploadSaveData from '@/components/saveData/UploadSaveData.vue';
import SettingInitialLevel from '@/components/item/SettingInitialLevel.vue';
import SaveData from '@/classes/saveData/saveData';
import SiteSetting from '@/classes/siteSetting';
import FirebaseManager from '@/classes/firebaseManager';
import LZString from 'lz-string';
import ShipStock from './classes/fleet/shipStock';
import ItemStock from './classes/item/itemStock';
import Fleet from './classes/fleet/fleet';
import CalcManager from './classes/calcManager';
import FleetInfo from './classes/fleet/fleetInfo';

export default Vue.extend({
  name: 'App',
  components: {
    SaveDataView,
    SaveDataTab,
    ShareDialog,
    SettingInitialLevel,
    UploadSaveData,
  },
  data: () => ({
    saveData: new SaveData(),
    mainSaveData: new SaveData(),
    drawer: false,
    configDialog: false,
    loading: true,
    somethingText: '',
    textareaHasError: false,
    readState: false as boolean | string,
    readInform: false,
    readInformText: '',
    readResultColor: 'success',
    setting: new SiteSetting(),
    editDialog: false,
    editedName: '',
    editedRemarks: '',
    shareDialog: false,
    urlParameters: {} as { data?: string; predeck?: string; stockid?: string },
    urlFragments: {} as { predeck?: string; ships?: ShipStock[]; items?: ItemStock[] },
    unsubscribe: undefined as unknown,
    rules: {
      simulationCountRange: (value: number) => !(value < 100 || value > 100000) || '100 ～ 100000で指定してください。',
    },
    readOnlyMode: false,
    disabledUpload: true,
    saveDialogTab: 'save',
    enabledFixDrawer: false,
    backupString: undefined as undefined | string,
    fileValue: undefined as File | undefined,
    disabledIndexedDB: false,
    fleetSelectDialog: false,
    selectableFleets: [] as { selected: boolean; fleet: Fleet; supportTypeName: string }[],
    tempManager: undefined as undefined | CalcManager,
  }),
  computed: {
    getCompletedAll() {
      return this.$store.getters.getCompletedAll;
    },
    isTempStockMode(): boolean {
      // 一時所持情報データがあるなら
      return this.$store.getters.getExistsTempStock;
    },
    getTextareaColor() {
      return this.somethingText && this.textareaHasError ? 'red darken-4' : 'primary';
    },
    enabledUndo(): boolean {
      const data = this.mainSaveData;
      return data ? data.tempIndex > 0 : false;
    },
    enabledRedo(): boolean {
      const data = this.mainSaveData;
      return data ? data.tempIndex < data.tempData.length - 1 : false;
    },
    isNameEmpty(): boolean {
      return this.editedName.length <= 0;
    },
    isManagerPage(): boolean {
      return this.$route.path.endsWith('/manager');
    },
    isAirCalcPage(): boolean {
      return this.$route.path.endsWith('/aircalc');
    },
    isLight(): boolean {
      return this.setting.themeDetail === 'light';
    },
    isIce(): boolean {
      return this.setting.themeDetail === 'ice';
    },
    isPink(): boolean {
      return this.setting.themeDetail === 'pink';
    },
    isGreen(): boolean {
      return this.setting.themeDetail === 'green';
    },
    isDark(): boolean {
      return this.setting.themeDetail === 'dark';
    },
    isDeepSea(): boolean {
      return this.setting.themeDetail === 'deep-sea';
    },
    hasItemUIBorder(): boolean {
      return this.setting.itemUI.border;
    },
    isItemUIBold(): boolean {
      return this.setting.itemUI.bold;
    },
    isItemUIRadius(): boolean {
      return this.setting.itemUI.radius;
    },
    showFooterBtn(): boolean {
      return this.isAirCalcPage && this.setting.visibleAirCalcMenuButton;
    },
    drawerFixed(): boolean {
      return this.enabledFixDrawer && this.setting.fixedDrawer;
    },
    routerViewClass(): string {
      if (this.showFooterBtn && this.drawerFixed) {
        return 'pl-2 pl-md-4 pr-12 pr-xl-4';
      }
      if (this.showFooterBtn && !this.drawerFixed) {
        return 'pl-2 pl-md-4 pr-12 pr-lg-4';
      }
      return 'px-2 px-md-4';
    },
    selectedAnyFleet(): boolean {
      return this.selectableFleets.some((v) => v.selected);
    },
  },
  watch: {
    getCompletedAll(value) {
      this.loading = !value;
      if (value) {
        this.loadURLInformation();
      }
      this.disabledIndexedDB = this.$store.state.disabledDatabase;
    },
    isTempStockMode(value) {
      this.readOnlyMode = !!value;
    },
  },
  created() {
    this.setting = this.$store.state.siteSetting as SiteSetting;
    this.saveData = this.$store.state.saveData as SaveData;
    // セーブデータの更新を購読
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'updateSaveData') {
        // 計算処理更新の購読 常に最新の状態を保つ
        this.saveData = state.saveData as SaveData;
      } else if (mutation.type === 'setMainSaveData') {
        // メインデータの更新を購読 常に最新の状態を保つ
        this.mainSaveData = state.mainSaveData as SaveData;
      } else if (mutation.type === 'updateSetting') {
        // 設定情報の更新を購読 常に最新の状態を保つ
        this.setting = state.siteSetting as SiteSetting;
        if (this.setting.themeDetail) {
          this.changeSiteTheme(this.setting.themeDetail);
        } else {
          // 基本のテーマ2種
          this.changeSiteTheme('dark');
        }

        if (!this.setting.fixedDrawer) {
          this.drawer = false;
        }
        this.onResize();
      }
    });

    // URLパラメータ or fragments取得 & 一時退避 => マスタ読み込み完了後に処理
    const { search, hash } = document.location;
    if (search || hash) {
      this.getUrlParams(search);
      this.setUrlFragments(hash);
      if (!this.loading) {
        this.loadURLInformation();
      }
    }
  },
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w = window as any;
    w.loadShipData = this.setShipStock;
    w.loadItemData = this.setItemStock;
    w.loadDeckBuilder = this.loadAndOpenFromDeckBuilder;

    document.addEventListener('keyup', this.keyupHandler);
  },
  methods: {
    closeSideBar() {
      this.drawer = false;
    },
    async loadURLInformation() {
      // 展開待ち中のデータがあれば読み込んで消す
      if (Object.keys(this.urlParameters).length) {
        if (this.urlParameters.data) {
          // 編成データ解析
          const urlData = SaveData.decodeURLSaveData(this.urlParameters.data);
          urlData.isMain = true;
          urlData.isActive = true;
          this.saveData.childItems.push(urlData);
          this.$store.dispatch('setMainSaveData', urlData);
          if (!this.isAirCalcPage) {
            // ページ遷移
            this.$router.push('aircalc');
          }
        } else if (this.urlParameters.predeck && this.loadAndOpenFromDeckBuilder(this.urlParameters.predeck)) {
          // デッキビルダー解析
          this.inform('編成の読み込みが完了しました。');
        } else if (this.urlParameters.stockid) {
          // 所持情報データ解析
          const stockData = await FirebaseManager.getAndRestoreStockData(this.urlParameters.stockid);

          // 一時所持情報にセットして管理ページを展開
          let available = false;
          if (stockData.shipStocks.length) {
            this.$store.dispatch('updateTempShipStock', stockData.shipStocks);
            available = true;
          }
          if (stockData.itemStocks.length) {
            this.$store.dispatch('updateTempItemStock', stockData.itemStocks);
            available = true;
          }

          if (available) {
            if (!this.$route.path.endsWith('/manager')) {
              // ページ遷移
              this.$router.push('manager');
            }
          } else {
            this.inform('所持情報の読み取りに失敗しました。', true);
          }
        }
        // 処理完了後除去
        this.urlParameters = {};
      } else if (Object.keys(this.urlFragments).length) {
        const informText: string[] = [];
        if (this.urlFragments.ships && this.urlFragments.ships.length) {
          // 艦隊反映
          informText.push('在籍艦娘の更新');
          this.setting.isStockOnlyForShipList = true;
          this.$store.dispatch('updateSetting', this.setting);
          this.$store.dispatch('updateShipStock', this.urlFragments.ships);
        }
        if (this.urlFragments.items && this.urlFragments.items.length) {
          // 装備反映
          informText.push('所持装備の更新');
          this.setting.isStockOnlyForItemList = true;
          this.$store.dispatch('updateSetting', this.setting);
          this.$store.dispatch('updateItemStock', this.urlFragments.items);
        }
        if (this.urlFragments.predeck && this.loadAndOpenFromDeckBuilder(this.urlFragments.predeck)) {
          informText.push('編成の読み込み');
        }
        if (informText.length) {
          this.inform(`URL fragmentより、${informText.join(', ')}が実行されました。`);
        }
        // 処理完了後除去
        this.urlFragments = {};
      }
    },
    readSomethingText() {
      this.readState = 'primary';
      // デッキビルダー形式データ読み込み試行
      if (this.loadAndConfirmDeckBuilder(this.somethingText)) {
        this.inform('デッキビルダー形式編成データを読み込みました。');
      } else if (this.setShipStock(this.somethingText)) {
        // 在籍艦娘データ読み込み試行
        this.inform('在籍艦娘データの更新が完了しました。');
      } else if (this.setItemStock(this.somethingText)) {
        // 所持装備データ読み込み試行
        this.inform('所持装備データの更新が完了しました。');
      } else {
        // 全部失敗
        this.inform('データの読み込みに失敗しました。正しいデータではない可能性があります。', true);
      }

      // 後始末と通知
      this.somethingText = '';
      this.readState = false;
    },
    loadAndConfirmDeckBuilder(builder: string): boolean {
      const text = builder.indexOf('predeck=') >= 0 ? builder.split('predeck=')[1] : builder;
      if (this.setting.importAllDeck) {
        return this.loadAndOpenFromDeckBuilder(text);
      }
      try {
        const converter = new Convert(this.$store.state.items, this.$store.state.ships);
        const manager = converter.loadDeckBuilder(text);
        if (!manager) {
          // 何もない編成データは無意味なので返す
          return false;
        }

        this.selectableFleets = [];
        for (let i = 0; i < manager.fleetInfo.fleets.length; i += 1) {
          const fleet = manager.fleetInfo.fleets[i];
          if (fleet.ships.some((v) => v.data.id > 0)) {
            this.selectableFleets.push({ selected: true, fleet, supportTypeName: fleet.getSupportTypeName() });
          }
        }
        if (this.selectableFleets.length > 1) {
          // 有効な艦隊が2つ以上
          this.fleetSelectDialog = true;
          // 一時退避
          this.tempManager = manager;
          return true;
        }

        return this.loadAndOpenFromDeckBuilder(text);
      } catch (error) {
        return false;
      }
    },
    loadAndOpenFromDeckBuilder(builder: string): boolean {
      // デッキビルダー形式データを計算データに設定して計算ページに移譲
      try {
        const converter = new Convert(this.$store.state.items, this.$store.state.ships);
        const manager = converter.loadDeckBuilder(builder);
        if (!manager) {
          // 何もない編成データは無意味なので返す
          return false;
        }
        this.expandCalcManager(manager);
        return true;
      } catch (error) {
        return false;
      }
    },
    importSelectedFleet(): void {
      if (!this.selectedAnyFleet) {
        return;
      }
      const manager = this.tempManager;
      if (!manager) {
        return;
      }
      const fleets = this.selectableFleets.filter((v) => v.selected).map((v) => v.fleet);
      // 選択された艦隊で置き換え
      manager.fleetInfo = new FleetInfo({ info: manager.fleetInfo, fleets });
      this.expandCalcManager(manager);
      this.fleetSelectDialog = false;
      this.inform('デッキビルダー形式編成データを読み込みました。');
    },
    expandCalcManager(manager: CalcManager): void {
      let mainData = this.saveData.getMainData();
      if (mainData) {
        // 敵情報はないので元の情報を使う
        manager.battleInfo = mainData.tempData[mainData.tempIndex].battleInfo;
        // もともと開いている編成があるならそこに追加
        mainData.tempData.push(manager);
        mainData.tempIndex += 1;
      } else {
        mainData = new SaveData();
        mainData.name = '外部データ';
        mainData.isActive = true;
        mainData.isMain = true;
        mainData.tempData = [manager];
        mainData.tempIndex = 0;
        mainData.tempSavedIndex = 0;
        this.saveData.childItems.push(mainData);
      }
      this.$store.dispatch('setMainSaveData', mainData);
      if (!this.isAirCalcPage) {
        // ページ遷移
        this.$router.push('aircalc');
      }
    },
    setShipStock(data: string): boolean {
      // 在籍艦娘情報を更新
      try {
        const shipList = Convert.readShipStockJson(data);
        if (shipList.length === 0) {
          // 何もない在籍データは無意味なので返す
          return false;
        }
        // 設定書き換え
        if (!this.loading) {
          this.setting.isStockOnlyForShipList = true;
          this.$store.dispatch('updateSetting', this.setting);
        }
        this.$store.dispatch('updateShipStock', shipList);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    setItemStock(data: string): boolean {
      // 所持装備情報を更新
      try {
        const itemList = Convert.readItemStockJson(data);
        if (itemList.length === 0) {
          // 何もない所持装備データは無意味なので返す
          return false;
        }
        // 設定書き換え
        if (!this.loading) {
          this.setting.isStockOnlyForItemList = true;
          this.$store.dispatch('updateSetting', this.setting);
        }
        this.$store.dispatch('updateItemStock', itemList);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    saveCurrentData() {
      // 現在計算画面で開かれているデータを取得
      const data = this.saveData.getMainData();
      if (data) {
        try {
          if (data.isUnsaved) {
            // リネームダイアログを表示
            this.handleSaveAndRenameCurrentData();
            return;
          }
          data.saveManagerData();

          // DB更新を促す
          this.$store.dispatch('updateSaveData', this.saveData);

          this.inform('保存しました。');
        } catch (error) {
          this.inform('保存に失敗しました。', true);
        }
      }
    },
    handleSaveAndRenameCurrentData() {
      // 名前変更ダイアログを展開する
      const data = this.saveData.getMainData();
      if (data) {
        this.editedName = data.name;
        this.editedRemarks = data.remarks;
        this.saveDialogTab = 'save';
        this.disabledUpload = data.isDirectory;
        this.editDialog = true;
      }
    },
    saveAndRenameCurrentData() {
      // 現在計算画面で開かれているデータを取得
      const data = this.saveData.getMainData();
      if (data) {
        try {
          let newData: SaveData;
          if (data.isUnsaved) {
            // 保存されていないファイル群から除去
            this.saveData.childItems = this.saveData.childItems.filter((v) => v !== data);
            newData = data;
          } else {
            newData = new SaveData();
            newData.tempData = [cloneDeep(data.tempData[data.tempIndex])];
            newData.tempIndex = 0;
          }

          newData.name = this.editedName;
          newData.remarks = this.editedRemarks;
          newData.editedDate = Date.now();
          newData.isUnsaved = false;
          newData.saveManagerData();

          const folder = this.saveData.childItems.find((v) => v.isDirectory);
          if (folder) {
            folder.childItems.push(newData);
            folder.sortChild();

            newData.isActive = true;

            // DB更新を促す
            this.$store.dispatch('updateSaveData', this.saveData);

            this.inform('保存しました。');
          } else {
            throw new Error('「保存されたデータ」フォルダーが見つかりませんでした。');
          }
        } catch (error) {
          this.inform('保存に失敗しました。', true);
        }
      }
      this.editDialog = false;
    },
    closeEditDialog() {
      this.editDialog = false;
    },
    undoClicked() {
      // 元に戻す
      const data = this.mainSaveData;
      if (data) {
        data.tempIndex -= 1;
        this.$store.dispatch('setMainSaveData', data);
      }
    },
    redoClicked() {
      // やり直す
      const data = this.mainSaveData;
      if (data) {
        data.tempIndex += 1;
        this.$store.dispatch('setMainSaveData', data);
      }
    },
    changeSiteTheme(theme: 'light' | 'dark' | 'deep-sea' | 'ice' | 'pink' | 'green') {
      const isDarkTheme = theme === 'dark' || theme === 'deep-sea';
      this.$vuetify.theme.dark = isDarkTheme;
      this.$vuetify.theme.themes.light.secondary = colors.grey.darken2;
      this.$vuetify.theme.themes.dark.primary = colors.blue.base;

      document.body.classList.remove('deep-sea', 'ice', 'pink', 'green');
      if (theme === 'deep-sea') {
        this.$vuetify.theme.themes.dark.primary = colors.blue.lighten1;
        document.body.classList.add(theme);
      }
      if (theme === 'ice' || theme === 'pink' || theme === 'green') {
        document.body.classList.add(theme);
      }

      this.setting.themeDetail = theme;
      this.updateItemUI();
    },
    toggleItemUIHasBorder() {
      this.setting.itemUI.border = !this.setting.itemUI.border;
      this.updateItemUI();
    },
    toggleItemUIIsBold() {
      this.setting.itemUI.bold = !this.setting.itemUI.bold;
      this.updateItemUI();
    },
    toggleItemUIIsRadius() {
      this.setting.itemUI.radius = !this.setting.itemUI.radius;
      this.updateItemUI();
    },
    updateItemUI() {
      if (!this.setting.itemUI) {
        return;
      }
      // 装備UI設定値を反映
      document.body.classList.remove('item-ui-border', 'item-ui-bold', 'item-ui-radius');
      if (this.setting.itemUI.border) {
        document.body.classList.add('item-ui-border');
      }
      if (this.setting.itemUI.bold) {
        document.body.classList.add('item-ui-bold');
      }
      if (this.setting.itemUI.radius) {
        document.body.classList.add('item-ui-radius');
      }
    },
    toggleConfigDialog() {
      if (!this.configDialog) {
        // 設定ダイアログを閉じると同時に保存
        // へんなのチェック
        if (this.setting.simulationCount > 100000) {
          this.setting.simulationCount = 100000;
        } else if (this.setting.simulationCount < 100) {
          this.setting.simulationCount = 100;
        }

        this.$store.dispatch('updateSetting', this.setting);
      }
    },
    toggleFleetSelectDialog() {
      if (!this.fleetSelectDialog) {
        this.tempManager = undefined;
        // 設定ダイアログを閉じると同時に保存
        this.$store.dispatch('updateSetting', this.setting);
      }
    },
    async clickedShare() {
      await (this.shareDialog = true);
      (this.$refs.shareDialog as InstanceType<typeof ShareDialog>).createdURL = '';
    },
    closeShareDialog() {
      this.shareDialog = false;
    },
    getUrlParams(value: string) {
      this.urlParameters = {};
      if (!value) return;
      const retVal: { [key: string]: string } = {};
      const array = value.slice(1).split('&');
      for (let i = 0; i < array.length; i += 1) {
        const str = array[i];
        const set = str.split('=');
        retVal[set[0]] = decodeURIComponent(set[1]);
      }
      this.urlParameters = Object.freeze(retVal);
      window.history.replaceState(null, '', `${document.location.pathname}#/`);
    },
    setUrlFragments(value: string) {
      // URLフラグメントより編成、装備、艦隊状況を読み込む
      this.urlFragments = {};
      if (!value) return;
      const sp = value.split('import:');
      if (!sp || sp.length < 2) return;
      this.$router.push({ path: '/' });

      const dataString = decodeURIComponent(sp[1]);
      let json;
      try {
        json = JSON.parse(dataString) as { ships?: unknown; items?: unknown; predeck?: unknown };
      } catch (error) {
        // 読み込んだデータが何かおかしい
        console.error(error);
        return;
      }
      try {
        this.urlFragments.predeck = JSON.stringify(json.predeck);
      } catch (e) {
        console.error(e);
      }
      try {
        this.urlFragments.ships = Convert.readShipStockJson(json.ships ? JSON.stringify(json.ships) : '');
      } catch (e) {
        console.error(e);
      }
      try {
        this.urlFragments.items = Convert.readItemStockJson(json.items ? JSON.stringify(json.items) : '');
      } catch (e) {
        console.error(e);
      }
    },
    inform(text: string, isError = false) {
      this.readInformText = text;
      this.readInform = true;
      this.readResultColor = isError ? 'error' : 'success';
    },
    async resetTempData() {
      this.$store.dispatch('updateTempShipStock', []);
      this.$store.dispatch('updateTempItemStock', []);
      this.inform('閲覧モードを終了しました');
    },
    changeUploadTabs(value: string) {
      if (value !== 'upload') return;

      const form = this.$refs.uploadSaveDataComp as InstanceType<typeof UploadSaveData>;
      if (form) {
        form.initControl();
      }
    },
    toggleMenuButton() {
      this.setting.visibleAirCalcMenuButton = !this.setting.visibleAirCalcMenuButton;
      this.$store.dispatch('updateSetting', this.setting);
    },
    clickCommentButton() {
      const form = this.$refs.saveDataTab as InstanceType<typeof SaveDataTab>;
      const mainData = this.saveData.getMainData();
      if (form && mainData) {
        form.showNameEditDialog(mainData);
      }
    },
    onResize() {
      if (this.enabledFixDrawer && window.innerWidth < 1480) {
        this.enabledFixDrawer = false;
      } else if (!this.enabledFixDrawer && window.innerWidth >= 1480) {
        this.enabledFixDrawer = true;
      }
    },
    downloadBackupFile() {
      const data = JSON.stringify(this.saveData.getMinifyData());
      const minify = LZString.compressToUTF16(data);
      const blob = new Blob([minify], { type: 'application/octet-stream' });
      saveAs(blob, `backup_${Convert.formatDate(new Date(), 'yyyyMMdd')}`);
    },
    async handleFileSelect(file: File) {
      this.backupString = undefined;
      if (!file) {
        return;
      }
      try {
        const minify = await file.text();
        const saveDataString = LZString.decompressFromUTF16(minify);
        // セーブデータとして復元できるかチェック
        if (saveDataString && SaveData.IsSaveData(JSON.parse(saveDataString) as SaveData)) {
          this.backupString = saveDataString;
        } else {
          throw new Error('復号に失敗');
        }
      } catch (error) {
        console.error(error);
        this.inform('読み込み失敗 -バックアップデータが壊れてるか、なんか違うファイルです', true);
      }
    },
    importBackupData() {
      const str = this.backupString;
      this.backupString = undefined;
      this.fileValue = undefined;
      if (str) {
        if (this.isAirCalcPage) {
          // ページ遷移
          this.$router.push('/');
        }
        const saveData = SaveData.getInstance(JSON.parse(str) as SaveData);
        saveData.isReadonly = true;

        for (let i = 0; i < saveData.childItems.length; i += 1) {
          const unsavedData = saveData.childItems[i];
          // ディレクトリ以外は非保存データなので書き換え
          if (!unsavedData.isDirectory) {
            unsavedData.isUnsaved = true;
            unsavedData.isActive = true;
          } else {
            unsavedData.isOpen = true;
            unsavedData.isReadonly = true;
          }
        }

        this.$store.dispatch('updateSaveData', saveData);
        this.inform('バックアップデータを復元しました。');
      }
    },
    keyupHandler(event: KeyboardEvent) {
      if (this.isAirCalcPage) {
        if (event.ctrlKey && event.code === 'KeyZ' && this.enabledUndo) {
          this.undoClicked();
        } else if (event.ctrlKey && event.code === 'KeyY' && this.enabledRedo) {
          this.redoClicked();
        }
      }
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      (this.unsubscribe as () => void)();
    }
  },
  destroyed() {
    document.removeEventListener('keyup', this.keyupHandler);
  },
});
